import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import AuthorizationService from '@/api/AuthorizationService';

export class HandleAccessGuard implements IRouterMiddleware {
  private service = new AuthorizationService();

  canActivate(to: MiddlewareRoute) {
    return (
      !!to.meta.validator &&
      (!to.meta.requiresAuth || this.service.userIsValidNotRefresh())
    );
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    if (
      typeof to.meta.validator === 'function' &&
      !to.meta.validator().isValid
    ) {
      next('/home');

      return;
    }

    next();
  }
}
